import React, { useEffect, useRef } from "react";
import { Drawer, Row, Col, Typography, Button, Form, Input, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import btnStyles from "../../../styles/Custom/Button.module.css";
import inputStyles from "../../../styles/Custom/Input.module.css";
import {
  createTherapyApi,
  updateTherapyApi,
} from "../../../services/therapy.services";

const TherapyForm = ({ open, setOpen, editData, refresh }) => {
  const [form] = Form.useForm();
  const formRef = useRef();

  useEffect(() => {
    if (editData?.id) {
      form.setFieldsValue(editData);
    } else {
      form.resetFields();
    }
  }, [editData]);

  const onFinish = (values) => {
    if (editData?.id) {
      updateTherapyApi(editData.id, values)
        .then(() => {
          message.success("Therapy Updated");
          refresh();
          setOpen(false);
        })
        .catch(() => message.error("Update Failed"));
    } else {
      createTherapyApi(values)
        .then(() => {
          message.success("Therapy Added");
          refresh();
          setOpen(false);
        })
        .catch(() => message.error("Create Failed"));
    }
  };

  return (
    <Drawer
      width="40%"
      open={open}
      closeIcon={null}
      title={
        <Row>
          <Col span={20}>
            <Typography style={{ fontSize: 20 }}>
              {editData?.id ? "Edit Therapy" : "Add Therapy"}
            </Typography>
          </Col>
          <Col span={4} className="flex-end">
            <CloseOutlined onClick={() => setOpen(false)} />
          </Col>
        </Row>
      }
      footer={
        <div className="flex-end">
          <Button
            type="primary"
            className={btnStyles.mdBtn}
            onClick={() => formRef.current.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item
          label="Therapy Name"
          name="name"
          rules={[{ required: true, message: "Enter therapy name" },{ max: 100, message: "Therapy name can contain max 100 characters only" }]}
        >
          <Input
            placeholder="Enter therapy name"
            className={inputStyles.mdInput}
            style={{ width: "300px" }}
          />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <Input.TextArea
            placeholder="Enter description"
            className={inputStyles.mdInput}
            style={{ width: "300px" }}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TherapyForm;
